import React from 'react';
import classnames from 'classnames';

import styles from './ToggleSwitch.module.scss';

type ToggleSwitchType = 'round' | 'moon';

interface ToggleSwitchProps {
  /** @ToggleSwitchType - Can be either "round" or "moon" */
  type?: ToggleSwitchType;
  /** @boolean - Prop that controls the toggle state */
  isActive?: boolean;
  /** @function - Called when the toggle is clicked */
  onClick?: (e: React.MouseEvent<Element>) => void;
}

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ type, isActive, onClick }) => (
  <label className={styles.switch}>
    <input type="checkbox" defaultChecked={isActive} />
    <span
      className={classnames(styles.slider, styles[`${type}`], isActive ? styles.active : '')}
      onClick={onClick}
    />
  </label>
);

export default ToggleSwitch;
